export default __webpack_public_path__ + "static/media/jenkins.6dc73108.png";